import { createContext, useMemo, useState } from "react";

/**
 * @typedef {object} HeaderContextValue
 * @property {boolean} isPanelOpened
 * @property {import("react").Dispatch<import("react").SetStateAction<boolean>>} setIsPanelOpened
 */

/** @type {HeaderContextValue} */
const DEFAULT_VALUES = {
  isPanelOpened: false,
  setIsPanelOpened: () => {},
};

export const HeaderContext = createContext(DEFAULT_VALUES);

export function HeaderContextProvider({ children }) {
  const [isPanelOpened, setIsPanelOpened] = useState(false);

  const value = useMemo(() => {
    return {
      isPanelOpened,
      setIsPanelOpened,
    };
  }, [isPanelOpened]);

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
}
